var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
            'pp-ui-button': _vm.applyStyles,
            'pp-ui-button-pause': _vm.applyStyles && _vm.playing,
            'pp-ui-button-play': _vm.applyStyles && !_vm.playing,
         },on:{"click":function($event){return _vm.togglePlayPause()}}},[(!_vm.playing)?_vm._t("play",function(){return [_c('Play')]}):_vm._t("pause",function(){return [_c('Pause')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }